import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IState {
  open: boolean;
  questionId: null | number;
}

const initialState: IState = {
  open: false,
  questionId: null
};

const testFeedbackModalSlice = createSlice({
  name: 'test-feedback',
  initialState,
  reducers: {
    setTestFeedbackModal: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setQuestionId: (state, action: PayloadAction<number>) => {
      state.questionId = action.payload;
    },
    resetQuestionId: state => {
      state.questionId = null;
    }
  }
});

export const { setTestFeedbackModal, setQuestionId, resetQuestionId } = testFeedbackModalSlice.actions;
export const testFeedbackModalReducer = testFeedbackModalSlice.reducer;
